<div class="container-fluid">
  <div class="row">
    <div class="d-md-flex row col-12 main-container" style="min-height: 100vh">
      <div class="col-sm-12 col-md-12 d-flex">
        <div class="w-100 align-self-center">
          <div class="row">

            <!--            <div class="col col-md-4 col-lg-2 text-end">-->
            <!--              <app-language-swicther></app-language-swicther>-->
            <!--            </div>-->
          </div>


          <!-- Language switcher for desktop - outside the row, aligned right -->
          <div class="text-end p-0 p-md-3 d-none d-lg-block">
            <app-language-swicther location="login-page"></app-language-swicther>
          </div>
          <div class="row align-items-stretch">

            <!-- Fixed-height hero slider -->
            <div class="col-sm-12 col-lg-6 col-xl-8 d-flex fix-height order-2 order-lg-1 mt-3 mt-lg-0">
              <div class="p-0 p-md-3 text-white h-100 w-100">
                <app-hero-slider></app-hero-slider>
              </div>
            </div>

            <!-- Right column vertically centered -->
            <div class="col-sm-12 col-lg-6 col-xl-4 d-flex align-items-center order-1 order-lg-2 mt-3 mt-lg-0">
              <div class="p-0 p-md-3 w-100">
                <div class="account-shadow">
                  <!-- Language switcher for mobile - inside account-shadow, top and center aligned -->
                  <div class="text-center mb-3 d-lg-none">
                    <app-language-swicther location="login-page"></app-language-swicther>
                  </div>
                  <router-outlet></router-outlet>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </div>
</div>